import React from 'react';
import Button from 'react-bootstrap/Button';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import { useNewVersionAvailable } from '../hooks/useNewVersionAvailable';

/**
 * Offers the refresh rather than reloading automatically: the portal has long forms that an
 * automatic reload would discard.
 */
const NewVersionToast = () => {
  const newVersionAvailable = useNewVersionAvailable();
  const [dismissed, setDismissed] = React.useState(false);

  return (
    <ToastContainer position="bottom-end" className="p-3 position-fixed">
      <Toast show={newVersionAvailable && !dismissed} onClose={() => setDismissed(true)}>
        <Toast.Header closeButton={false}>
          <strong className="me-auto">Update available</strong>
        </Toast.Header>
        <Toast.Body>
          <p className="mb-3">
            A new version of the portal has been released. Refresh to load it. Any unsaved changes will be lost.
          </p>
          <div className="d-flex gap-2">
            <Button variant="primary" size="sm" onClick={() => window.location.reload()}>
              Refresh now
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={() => setDismissed(true)}>
              Later
            </Button>
          </div>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default NewVersionToast;
